import { Component, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "zbd-simple-toggle",
    template: `
        <div class="zas-row">
            <div
                class="zas-main-col"
                [ngClass]="{
                    'zas-expanded-simple-toggleable': isOpen,
                    'zas-collapsed-simple-toggleable': !isOpen,
                }"
                (click)="toggleVisibility()"
                class="clickable"
            >
                <h4>
                    <span
                        [ngClass]="{
                            'icon-icon-cta': !isOpen,
                            'icon-icon-cta-down': isOpen,
                        }"
                    ></span
                    >&nbsp;{{ title }}
                    <span
                        *ngIf="showIcon"
                        (click)="iconAction()"
                        class="zas-header-icon inline-icon"
                        [ngClass]="iconCSS"
                        >&nbsp;</span
                    >
                    <div class="right">
                        <span
                            class="zbd-validation-indicator"
                            [ngClass]="{
                                'icon-dot-indicator-three zbd-invalid':
                                    !isValid && isValidateable,
                                'icon-hook zbd-valid':
                                    isValid && isValidateable,
                            }"
                        ></span>
                    </div>
                </h4>
            </div>
        </div>
        <hr class="underline" />
        <div *ngIf="isOpen">
            <ng-content></ng-content>
        </div>
    `,
    styles: [
        `
            .clickable {
                cursor: pointer;
            }

            .inline-icon {
                float: right;
                margin-right: 0px;
            }

            .underline {
                margin: -20px 20px 30px 20px;
            }
        `,
    ],
})
export class SimpleToggleableComponent {
    @Output() opened: EventEmitter<SimpleToggleableComponent> =
        new EventEmitter<SimpleToggleableComponent>();
    @Output() closed: EventEmitter<SimpleToggleableComponent> =
        new EventEmitter<SimpleToggleableComponent>();
    @Input() title: string;
    @Input() isOpen: boolean;
    @Input() iconCSS: string;
    @Input() iconAction: () => void;
    @Input() showIcon: boolean;
    @Input() isValid: boolean;
    @Input() isValidateable: boolean;

    constructor() {}

    toggleVisibility(): void {
        this.isOpen = !this.isOpen;
        if (this.isOpen === true) {
            this.opened.emit(this);
        } else {
            this.closed.emit(this);
        }
    }

    close(): void {
        this.isOpen = false;
        this.closed.emit(this);
    }

    open(): void {
        this.isOpen = true;
        this.opened.emit(this);
    }
}
